<template>
    <div id="billingReversingJournalEntry">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                 <div class="page-name">
                     <div class="page-title"> Billing Reversing Journal Entry</div>
                    <!-- <router-link v-if="canAdd" class="btn btn-primary pull-right" v-bind:to="{name: 'ChargeCreate'}" >
                        <i class="fp-add"> </i>  Add
                    </router-link> -->
                    <button type="submit" class="btn btn-primary pull-right" v-on:click.prevent="openModal()"><i class="fp-add"> </i>  Add</button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content charge-list">
                        <data-table-filter-config :moduleName="'billReversingJEHeaderList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <p v-if="batchProcess1" class="alert-success p-2">{{createBillRevJEMsg}}</p>
                        <p v-if="batchProcess2" class="alert-success p-2">{{postBillRevJEMsg}}</p>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'billReversingJEHeaderList'" :position="'top'">
                                </custom-pagination>

                                <vue-good-table
                                        id="billRevJEHeaderTable"
                                        ref="billingReversingJournalEntryHeaderList"
                                        mode="remote"
                                        @on-page-change="onPageChange"
                                        @on-sort-change="onSortChange"
                                        @on-column-filter="onColumnFilter"
                                        @on-per-page-change="onPerPageChange"
                                        :totalRows="totalRecords"
                                        title="Billing Reversing Journal Entry Header"
                                        :columns="userColumns"
                                        :rows="rows"
                                        :paginate="true"
                                        :paginationOptions="{
                                            enabled: false,
                                            position: 'both',
                                            perPage: perPage,
                                            perPageDropdown:dropDownPerPage,
                                            dropdownAllowAll: false,
                                         }"
                                         :select-options="{
                                            enabled: true,
                                            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                            selectionInfoClass: 'custom-class',
                                            selectionText: 'rows selected',
                                            clearSelectionText: 'clear',
                                        }"
                                        :sort-options="{
                                            enabled: true,
                                        }"
                                    >
                                    <div slot="selected-row-actions">
                                          <button v-if="canDelete" id="deleteBillRevJEDetail" v-on:click.prevent="deleteBillRevJEConfirm" class="btn btn-primary">Delete</button>
                                    </div>
                                     <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">

                                          <div v-if="props.column.field == 'action'">
                                              <template v-if="props.row['status'] != 'In Progress'">
                                                <router-link class="btn btn-secondary" v-bind:to="{name: 'BillingReversingJEDetails',params:{id:props.row.id}}"> <i class="fp-view"> </i> View</router-link>
                                              </template>
                                              <template v-if="props.row['status'] == 'Created' && canPost">
                                                  <button type="submit" class="btn btn-secondary" v-on:click.prevent="postBillRevJEConfirm(props.row.id)" >
                                                          <i class="fp-save"> </i> Post
                                                  </button>
                                              </template>

                                          </div>
                                          <div v-else-if="props.column.field == 'principal_payment' || props.column.field ==  'interest'
                                          || props.column.field ==  'note_balance'">
                                            $ {{ amountFormat(props.formattedRow[props.column.field]) }}
                                          </div>
                                          <!--div v-else-if="props.column.field ==  'intereset_posted' || props.column.field ==  'principal_posted' ">
                                            <template v-if="props.formattedRow[props.column.field] == null">
                                              <label class="control-label" for="vehicle_id">N</label>
                                            </template>
                                            <template v-else>
                                            <label class="control-label" for="vehicle_id">Y</label>
                                            </template>
                                          </div-->
                                          <div v-else>
                                              {{props.formattedRow[props.column.field]}}
                                          </div>
                                        </div>
                                    </template>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
        <div class="modal fade make-bill-date-modal" id="billRevJeModal" ref="billRevJeModal" data-backdrop="static" data-keyboard="false" aria-labelledby="makePaymentModal" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Add Bill Reversing Journal Entry</h5>
                    <button type="button" class="close" id="btnModalClose" v-on:click="hideModal()">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="form-row">
                        <div class="col-6 form-group">
                            <label class="control-label require" for="year">Year</label>
                            <div class="input-group">
                                <input type="number" class="form-control" id="year" name="year" v-model="year">
                            </div>
                            <div class="field-error">{{ year_error_msg }}</div>
                        </div>
                        <div class="col-6 form-group">
                            <label class="control-label require" for="period">Period</label>
                            <div class="input-group">
                                <input type="number" class="form-control" id="period" name="period" v-model="period">
                            </div>
                            <div class="field-error">{{ period_error_msg }}</div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-primary" id="btnBillRevJeHeaderAdd" v-on:click="addBillRevJeHeader()"> Submit </button>
                    <button class="btn btn-tertiary" id="btnBillRevJeHeaderModalCancel" v-on:click="hideModal()"> Cancel </button>
                </div>
            </div>
        </div>
    </div>
    </div>


</template>

<script>


    import Vue from 'vue';
    import EventBus from ".././event-bus";




    import VueSSE from 'vue-sse'
    Vue.use(VueSSE);
    import {commonMixins} from '../../mixins/commonMixins';
    import {dataTableMixins} from '../../mixins/dataTableMixins';

    let msgServer
    export default {
        name: "billReversingJournalEntryHeader",
        metaInfo() {
            return {title: "Billing Reversing Journal Entry | " +process.env.COPYRIGHT_NAME}
        },
        mixins:[commonMixins,dataTableMixins],
        data: () => ({

            firstLoad : 0,
            year : "",
            period : "",
            flag : "",
            userColumns:[],
            columns: [
                {
                    label: 'Year',
                    field: 'year',
                    html: true,
                    filterable: true,
                    fpFieldType:"integer",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Year", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                },
                {
                    label: 'Period',
                    field: 'period',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Period", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Batch',
                    field: 'batch',
                    hidden:false,
                    filterable: false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Charge Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Created',
                    field: 'created',
                    hidden:false,
                    filterable: false,
                    html: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Charge Type", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Day','Week','Month','Mile','Fixed'],// dropdown (with selected values) instead of text input
                        // filterFn: this.onColumnFilter, //custom filter function that
                        // trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Status',
                    field: 'status',
                    hidden:false,
                    filterable: false,
                    html: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Rate", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Post Date',
                    field: 'post_date',
                    html: false,
                    filterable: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Filter", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Actions',
                    field: 'action',
                    sortable: false,
                    hidden:false,
                },

            ],
            rows: [],
            totalRecords: 0,
            permissions:[],
            loading:false,
            hidden:true,
            cantAccessPage:"",
            canAdd:false,
            canUpdate:false,
            year_error_msg: "",
            period_error_msg: "",
            batchId: "",
            batchProcess1:false,
            batchNum1:'',
            batchProcess2:false,
            batchNum2:'',
            batchNum3:'',
            createBillRevJEMsg:'',
            postBillRevJEMsg:'',
            action:'',
            subSystemFlag:"",
            subSystemInvArr:[],
            batchError:false,
            batchErrorMsg:"",
            canDelete: false,
            canPost: false,
        }),
        watch:{
            year:function(){
                if(this.year.length>4){
                    this.year = this.year.slice(0,4);
                }
            },
            period:function(){
                if(this.period.length>2){
                    this.period = this.period.slice(0,2);
                }
            },
            permissions: function(permission){
                var self = this;
                permission.forEach(function (permissions) {
                    if(permissions.name == 'list_bill_reversing_journal_entry_header') {
                        self.cantAccessPage = true;
                    }
                    if(permissions.name == 'add_bill_reversing_journal_entry_header') {
                        self.canAdd = true;
                        self.canUpdate = true;
                    }
                    if(permissions.name == 'delete_bill_reversing_journal_entry_header') {
                        self.canDelete = true;
                    }
                    if(permissions.name == 'post_bill_reversing_journal_entry') {
                        self.canPost = true;
                    }
                });
                if(self.cantAccess == ''){
                    self.cantAccess = false;
                }
            }
        },
        created: function() {
            this.serverParams.sort = {field:"id",type:"desc"};
        },
        mounted: function () {

            this.getPermissions();

        },
        beforeDestroy() {
        // Make sure to close the connection with the events server
        // when the component is destroyed, or we'll have ghost connections!
            msgServer.close();
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.billingReversingJournalEntryHeaderList.unselectAllInternal();
            },
            openModal: function(){
                $("#billRevJeModal").modal("show");
            },
            hideModal: function(){
                $("#billRevJeModal").modal("hide");
            },
            checkBatchStatus:function(){
                var self =  this;
                this.$sse(process.env.ROOT_API + '/check/batch-status/'+self.batchId, { format: 'json' }) // or { format: 'plain' }
                .then(sse => {
                    // Store SSE object at a higher scope
                    msgServer = sse;

                    // Listen for messages without a specified event
                    sse.subscribe('', data => {
                        if ( data.status == "1") {
                            if (data.type != undefined && data.type == 'post_bill_rev_je'){
                                self.postBillRevJEMsg = 'Billing reversing journal entries are posted successfully';
                                setTimeout(function(){
                                    self.postBillRevJEMsg = '';
                                    self.batchProcess2 = false;
                                    // self.$router.push('/billing-reversing-journal-entry');
                                },4000);
                            }else if (data.type != undefined && data.type == 'bill_rev_je_header'){
                                self.createBillRevJEMsg = 'Billing reversing journal entries created successfully';
                                setTimeout(function(){
                                    self.createBillRevJEMsg = '';
                                    self.batchProcess1 = false;
                                    // self.$router.push('/billing-reversing-journal-entry');
                                },4000);
                            }else{
                                self.batchProcess1 = false;
                            }
                            self.loadList();
                            sse.close();
                        }else if (data.status == "2") {
                            if (data.type != undefined && data.type == 'post_bill_rev_je'){
                                self.batchProcess2 = false;
                                self.postBillRevJEMsg = 'Billing reversing journal entries are not created';
                            }if (data.type != undefined && data.type == 'bill_rev_je_header'){
                                self.batchProcess3 = false;
                                self.createBillRevJEMsg = 'Billing reversing journal entries are not created';
                            }else{
                                self.batchProcess1 = false;
                            }
                            self.batchError = true;
                            self.batchErrorMsg = data.message;
                            sse.close();
                        }
                    });

                })
                .catch(err => {
                    // When this error is caught, it means the initial connection to the
                    // events server failed.  No automatic attempts to reconnect will be made.
                    console.error('Failed to connect to server', err);
                });
            },
            addBillRevJeHeader: function(){
                var self = this;
                var error = false;
                self.action = 'add_bill_rev_je';
                if (!self.year || self.year == null || self.year == "") {
                    self.year_error_msg = "Year is Required.";
                    error = true;
                }

                if (!self.period || self.period == null || self.period == "") {
                    self.period_error_msg = "Period is Required.";
                    error = true;
                }

                if(self.period>12){
                    self.period_error_msg = "Invalid Month.";
                    error = true;
                }

                if(!error){
                    $.ajax({
                        url: process.env.ROOT_API + "/bill-reversing-journal-entry/create",
                        type: "POST",
                        headers: this.ajxHeaders,
                        dataType: "json",
                        data:{
                            year: self.year,
                            period: self.period,
                        },
                        success: function (data) {
                            self.year = "";
                            self.period = "";
                            self.year_error_msg = "";
                            self.period_error_msg = "";
                            self.hideModal();
                            self.$swal('', 'Billing Reversing Journal Entries Created', 'success');
                            EventBus.$emit('clear-all-flags', false);
                            if (data.batch_id != undefined){
                                self.batchId = data.batch_id;
                                self.batchNum1 = data.batch;
                                self.batchProcess1 = true;
                                self.createBillRevJEMsg = 'Current batch'+ self.batchNum2+ ' for billing-reversing-journal-entry is processing please wait!';
                                self.checkBatchStatus();
                            }

                            self.loadList();
                            return;
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            if (jqXHR.status == 0) {
                                self.errorMsg = "Remote server cannot be reached";
                            } else {
                                //redirect to login page if user not authenticated
                                if (jqXHR.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("tkn");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/");
                                }
                                self.error = jqXHR.responseJSON.message;
                            }
                        }
                    });
                }
            },

            loadList: function(){
                var self = this;
                self.loading = true;

                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    all:self.serverParams.selectedAll,
                };

                $.ajax({
                    url: process.env.ROOT_API + "/bill-reversing-journal-entry/list",
                    type: "POST",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    data:fields,
                    success: function (data) {
                        self.loading = false;
                        self.rows = data.content.row;
                        self.totalRecords = data.content.totalRecords;
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            postBillRevJEConfirm: function(id){
                var self = this;
                self.$swal({
                    title: 'Are you sure that you want to post this Billing Reversing Journal Entry?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        self.postBillRevJE(id);
                    }
                });
            },
            postBillRevJE: function(id){
                var self = this;
                self.loading = true;
                self.action = 'post_bill_rev_je';
                $.ajax({
                    url: process.env.ROOT_API + "/bill-reversing-journal-entry/post",
                    type: "POST",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    data:{
                        id: id,
                    },
                    success: function (data) {
                        self.loading = false;
                        self.$swal('', 'Billing Reversing Journal Entries Posted', 'success');
                        EventBus.$emit('clear-all-flags', false);
                        if (data.batch_id != undefined){
                            self.batchId = data.batch_id;
                            self.batchNum2 = data.batch;
                            self.batchProcess2 = true;
                            self.postBillRevJEMsg = 'Current batch'+ self.batchNum2+ ' for billing-reversing-journal-entry is processing please wait!';
                            self.checkBatchStatus();
                        }

                        self.loadList();
                        return;
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            deleteBillRevJEConfirm: function(){
                var self = this;
                self.$swal({
                    title: 'Are you sure that you want to delete these Billing Reversing Journal Entry?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        self.deleteBillRevJE();
                    }
                });
            },
            deleteBillRevJE: function(){
                var self = this;
                var data = this.$refs['billingReversingJournalEntryHeaderList'].selectedRows;
                var idArr = [];
                for (var i = 0; i < data.length; i++) {
                    idArr.push(this.$refs['billingReversingJournalEntryHeaderList'].selectedRows[i].id);
                }
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/bill-reversing-journal-entry/delete",
                    type: "POST",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    data:{
                        idArr: idArr,
                    },
                    success: function (data) {
                        self.loading = false;

                        if(data.status == 'success'){
                            self.$swal('', 'Billing Reversing Journal Entries Deleted', 'success');
                            EventBus.$emit('clear-all-flags', false);
                            self.loadList();
                            return;
                        }

                        if(data.status == 'error'){
                            self.$swal('',data.message,data.status);
                            EventBus.$emit('clear-all-flags', false);
                            self.loadList();
                            return;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
        }
    };
</script>




// WEBPACK FOOTER //
// src/components/accounting/BillingReversingJournalEntry.vue